import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'

import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'ContentForm',
  data,
  methods,
  mounted,
  watch,
  components: {
    Editor,
  },
}
